import { API_BASE_URL } from './api/config';

export const saveUserInfo = async (email, field, salary) => {
  try {
    const response = await fetch(`${API_BASE_URL}/users/submit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        field,
        salary,
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('User info saved successfully:', data);
    return data;
  } catch (error) {
    console.error("Error saving user info:", error);
    return null;
  }
};